import {
  getContentType,
  getFilePath,
  buildPublicImageURL,
} from 'helpers/firebase';
import { storage } from 'services/firebase';
import { FetchResponse } from 'models';
import { MediaType } from 'models/forms';
import Mapper from 'data/Mapper';

export const upload = (
  file: Blob | File,
  mediaType: MediaType,
  fileName?: string,
): Promise<Promise<FetchResponse<string>>> => {
  const contentType = getContentType(mediaType);
  const filePath = getFilePath(mediaType, fileName);
  const metadata = {
    cacheControl: 'public,max-age=31536000',
    contentType,
  };
  return storage
    .ref(filePath)
    .put(file, metadata)
    .then((snapshot) => {
      let fileUrl = snapshot.ref.toString();
      if (mediaType === MediaType.IMAGE) {
        fileUrl = buildPublicImageURL(fileUrl);
      }
      return Mapper.mapSuccesResponse(fileUrl);
    })
    .catch((error) => {
      return Mapper.mapError(error);
    });
};

export const remove = (path: string): Promise<FetchResponse<boolean>> => {
  return storage
    .ref(path)
    .delete()
    .then(() => {
      return Mapper.mapSuccesResponse(true);
    })
    .catch((error) => {
      return Mapper.mapError(error);
    });
};
